import { combineReducers } from 'redux';
import UserReducer from './user-reducer';
import globalReducer from './global-reducer';

export default combineReducers({
    user: UserReducer,
    global: globalReducer
});